export const infoPublicSession = `
query {
    infoForPublicDataSession {
        expireDate
        creationDate
        lastUpdateDate
        guid
        teamRepository
    }
}`;